import subpropertyListStore from '@modules/subproperty/subproperty-list-store';
import subpropertyViewStore from '@modules/subproperty/subproperty-view-store';
import subpropertyImporterStore from '@modules/subproperty/subproperty-importer-store';
import subpropertyFormStore from '@modules/subproperty/subproperty-form-store';
import subpropertyDestroyStore from '@modules/subproperty/subproperty-destroy-store';
import subpropertyDashboardStore from '@modules/subproperty/subproperty-dashboard-store';
import subpropertyRequirementsStore from '@modules/subproperty/subproperty-requirements-store';
import subpropertyDashboardFinantialStore from '@modules/subproperty/subproperty-dashboard-finantial-store';
import subpropertyCustomizeStore from '@modules/subproperty/subproperty-customize-store';
import subpropertyFeeInfoStore from '@modules/subproperty/subproperty-fee-info-store';

export default {
  namespaced: true,

  modules: {
    requirements: subpropertyRequirementsStore,
    dashboard: subpropertyDashboardStore,
    dashboardFinantial: subpropertyDashboardFinantialStore,
    destroy: subpropertyDestroyStore,
    form: subpropertyFormStore,
    list: subpropertyListStore,
    view: subpropertyViewStore,
    importer: subpropertyImporterStore,
    customize: subpropertyCustomizeStore,
    feeInfo: subpropertyFeeInfoStore,
  },
};
